import { Fragment } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import { useNavigationItemContext } from 'hb-react/backoffice/components/ImageLibrary/context/NavigationItemProvider';

import NavItem from './NavItem';

const Navigation = () => {
  const { activeItem, navigationItems, setActiveItem } =
    useNavigationItemContext();

  return (
    <Wrapper>
      {activeItem &&
        navigationItems?.map((navigationItem) => (
          <Fragment key={navigationItem.id}>
            <NavItem
              {...navigationItem}
              isActive={navigationItem.id === activeItem.id}
              onClick={() => setActiveItem(navigationItem)}
            />
          </Fragment>
        ))}
    </Wrapper>
  );
};

export default Navigation;

const Wrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  height: '100%',
  width: '240px',
}))`
  border-right: 1px solid #e3eaef;
`;
